import ChevronRightIcon from "assets/icon/ChevronRightIcon";
import { MainBodyCard, PagesTitle } from "components/Cards";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Setting(){
    let navigate = useNavigate()
    
    const [isAdmin, setIsAdmin] = useState(localStorage.getItem('IsAdmin'))

    return(
        <MainBodyCard>
            <PagesTitle title='Settings' />
            
            <div className="bg-white p-4 rounded-xl shadow-sm border text-sm mt-4">
                { isAdmin === "1" && (
                    <div>
                        <div className="mb-2">
                            <span className="font-semibold text-lg">User Setting</span>
                        </div>
                        <hr />
                        <button className="px-4 py-4  w-full text-left flex justify-between hover:bg-slate-100 transition-all" onClick={() => {navigate("/setting/user")}}>
                            <span className="">User</span>
                            <ChevronRightIcon className="fill-black w-6" />
                        </button>
                        <hr />
                    </div>
                )}
                
                <div className="mt-4 mb-2">
                    <span className="font-semibold text-lg">General Setting</span>
                </div>
                <hr />
                
                <button className="px-4 py-4  w-full text-left flex justify-between hover:bg-slate-100 transition-all" onClick={() => {navigate("/setting/tax")}}>
                    <span className="">Tax</span>
                    <ChevronRightIcon className="fill-black w-6" />
                </button>
                <hr />

                <button className="px-4 py-4  w-full text-left flex justify-between hover:bg-slate-100 transition-all" onClick={() => {navigate("/setting/expense-category")}}>
                    <span className="">Expense Category</span>
                    <ChevronRightIcon className="fill-black w-6" />
                </button>
                <hr />
            </div>
        </MainBodyCard>
    )
}